module.exports = __webpack_public_path__ + "static/media/2 (8).a0635da2.jpg";